import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { background_onboarding } from "../../constants/icons";

const SuccessStep = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);
  const { accountType } = useSelector((state) => state.signup);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/login");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const getAccountTypeText = () => {
    switch (accountType) {
      case "club":
        return "Your club registration is complete.";
      case "agency":
        return "Your agency registration is complete.";
      case "agent":
        return "Your agent registration is complete.";
      case "lawyer":
        return "Your lawyer registration is complete.";
      case "player":
        return "Your player registration is complete.";
      case "staff":
        return "Your staff registration is complete.";
      case "organizer":
        return "Your organizer registration is complete.";
      default:
        return "Your registration is complete.";
    }
  };

  return (
    <div className="fixed inset-0 w-full h-full flex flex-col items-center justify-center bg-gradient-to-r from-[#1A3750] to-[#1C2536]">
      <div className="text-center text-white">
        <h1 className="text-[33.3px] font-bold mb-4">Congratulations!</h1>
        <p className="text-[16px] font-normal mb-8">
          {getAccountTypeText()} Redirecting to home in{" "}
          <span className="font-bold">{countdown}s</span>
        </p>
        <button
          onClick={() => navigate("/login")}
          className="px-4 py-2 rounded-lg bg-[#2283FF] text-white hover:bg-[#1a6cd4] transition-colors"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default SuccessStep;
